import "./index.css";
import { APITester } from "./APITester";
import { version } from "omuso/package.json";

export function App() {
	return (
		<>
			<header>
				<hgroup>
					<h1>OMUSO (Markdown) Parser</h1>
					<h4>v{version}</h4>
				</hgroup>
				<a href="https://github.com/marcmarine/omuso" className="va-button">
					GitHub
				</a>
			</header>
			<APITester />
		</>
	);
}

export default App;
